import { render, staticRenderFns } from "./TermsPop1.vue?vue&type=template&id=795b1980&"
import script from "./TermsPop1.vue?vue&type=script&lang=ts&"
export * from "./TermsPop1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports